module.exports = __webpack_public_path__ + "static/media/img6.76c5af36.jpg";